module.exports = __webpack_public_path__ + "img/down-arrow.93abb9b6.svg";